import { StyleSheet } from "react-native";

import { Text } from "@ctv/shared-core/src";

export default function RequiredLabel() {
  return (
    <Text ink="alert" style={styles.required}>
      {" *"}
    </Text>
  );
}

const styles = StyleSheet.create({
  required: {
    // @ts-expect-error -- type does not exist in React Native
    userSelect: "none",
  },
});
